import React, { useEffect, useContext, useState } from "react";
import ReactDOM from "react-dom";
import ModalContext from "./Context";

//import Exclamation from "assets/images/exclamation.svg";
//import Success from "assets/images/success.svg";

export enum statusEnum {
    success = "success",
    error = "error",
}

interface ModalProps {
    show: boolean;
    title?: string;
    onClose: (e?: any) => void;
    onTopClose?: (e?: any) => void;
    onConfirm: (e?: any) => void;
    cancelButton?: string;
    confirmButton?: string;
    message: string | React.ReactElement;
    status?: statusEnum;
    errorCount?: string;
    subTitle?: string;
    dontDisplayIconClose?: boolean;
    zIndexIncrement?: number;
}

const ConfirmModal: React.FC<ModalProps> = ({
    show,
    title,
    onClose,
    onTopClose,
    onConfirm,
    cancelButton,
    confirmButton,
    message,
    status,
    errorCount,
    subTitle,
    dontDisplayIconClose,
    zIndexIncrement = 0,
}) => {
    const modal = useContext(ModalContext);
    const [element, setPortalElement] = useState<HTMLElement | undefined>(undefined);

    useEffect(() => {
        if (modal.isMain) {
            if (show) {
                document.documentElement.classList.add("modal-open");
            } else {
                document.documentElement.classList.remove("modal-open");
            }
        }
    }, [show, modal.isMain]);

    useEffect(() => {
        const newElement = document.createElement("div") as HTMLElement;
        document.body.appendChild(newElement);
        setPortalElement(newElement);
        return () => {
            if (modal.isMain) {
                document.documentElement.classList.remove("modal-open");
            }
            document.body.removeChild(newElement);
        };
    }, [modal.isMain]);

    const zIndex = modal.overlay.zIndex + zIndexIncrement;

    if (show && element) {
        return ReactDOM.createPortal(
            <div className="popup-filter" style={{ zIndex }}>
                <div className="popup-export">
                    <div className="popup-header">
                        {title ? <div className="popup-title">{title}</div> : null}
                        {!dontDisplayIconClose && (
                            <button
                                type="button"
                                className="icon-cross close-popup"
                                onClick={onTopClose || onClose}
                            ></button>
                        )}
                        {subTitle ? <div className="popup-subtitle">{subTitle}</div> : null}
                    </div>
                    <div className="popup-content">
                        <ModalContext.Provider
                            value={{
                                isOpened: true,
                                overlay: { zIndex: zIndex + 50 },
                                isMain: false,
                            }}
                        >
                            {/* {status === statusEnum.success ? (
                                    <div className="modal_icon">
                                        <img src={Success} alt="success" />
                                    </div>
                                ) : (
                                    <div className="modal_icon">
                                        <img src={Exclamation} alt="exclamation" />
                                    </div>
                                )} */}
                            <div className="popup-message">{message}</div>

                            <div style={{ display: "flex", justifyContent: "center" }}>
                                {confirmButton && (
                                    <button
                                        style={{ margin: "0 5px" }}
                                        type="button"
                                        className="cta cta--primary margin-auto"
                                        title={confirmButton}
                                        onClick={onConfirm}
                                    >
                                        {confirmButton}
                                    </button>
                                )}
                                {cancelButton && (
                                    <button
                                        style={{ margin: "0 5px" }}
                                        type="button"
                                        className="cta cta--primary margin-auto"
                                        title={cancelButton}
                                        onClick={onClose}
                                    >
                                        {cancelButton}
                                    </button>
                                )}
                            </div>
                        </ModalContext.Provider>
                    </div>
                </div>
            </div>,
            element
        );
    }
    return null;
};

export default ConfirmModal;
